import {formatImageContent} from "@/components/file_process_js/ function_process/vision_process";
import {fileStatusChange, isAllowed} from "@/components/file_process_js/utils";
import store from "@/store";

async function parseRuleResultMD(fileInfo) {
    console.log("getParseRuleResultMD start ", fileInfo)
    const context = formatImageContent(fileInfo.text_content)
    if (!context) {
        console.log("getParseRuleResultMD !context", fileInfo)
        return null
    }
    const resulByRule = getParseResultByRule(context);
    console.log("getParseRuleResultMD", fileInfo, resulByRule)
    if (resulByRule) {
        console.log("fileInfo get parse by rule", resulByRule)
        fileInfo.final_result = resulByRule
        fileStatusChange(fileInfo, "parsed", 800)
        await store.dispatch("fileCheckListLevelChange")
    }
}


export function getParseRuleResultMD(fileInfo) {
    const fileConfig = store.state.fileConfig
    const ruleConfig = fileConfig.rule_config

    const allowFileType = ruleConfig.allow_file_type
    const allowFilePathWord = ruleConfig.allow_file_path_word
    const notAllowFileType = ruleConfig.not_allow_file_type
    const notAllowFilePathWord = ruleConfig.not_allow_file_path_word

    const fileIsAllowed = isAllowed(fileInfo.file_path, fileInfo.file_type, allowFileType, allowFilePathWord, notAllowFileType, notAllowFilePathWord)
    // console.log("allowFileType, allowFilePathWord,notAllowFileType,notAllowFilePathWord", fileInfo.file_path, allowFileType, allowFilePathWord,notAllowFileType,notAllowFilePathWord)
    // console.log("getParseRuleResultMD", fileInfo.file_path, fileIsAllowed)

    return fileIsAllowed ? parseRuleResultMD : null
}



function getParseResultByRule(context) {
    const tables = context['tables']

    const companyRule = checkPointCompany (tables)
    console.log("companyRule!!!!!", companyRule)

    if (companyRule) {
        return matchDataByRule(tables, companyRule)
    }
    return null
}

export const checkPointCompany = function(tableDataList) {
    const ruleMapping = store.state.ruleConfig.ruleMapping;
    let resRule = null
    for (let i = 0; i < ruleMapping.length; i++) {
        const rule = ruleMapping[i];
        const valid = tableDataList.find(t => {
            return t.find(c => {
                return c['row'] === rule['validLocation'][0] && c['col'] === rule['validLocation'][1] && c['content'] === rule['keyStr']
            })
        })
        if (valid) {
            resRule = rule
        }
    }
    return resRule
}

function matchDataByRule (tables, rule) {
    const keywordMapping = store.state.ruleConfig.keywordMapping
    const companyId = rule.companyId
    const keyCol = rule.keyCol
    const valueColList = rule.valueCol
    const keywordMap = keywordMapping[companyId]
    const res = []
    const unexpected = []
    console.log("matchDataByRule table", tables)

    tables.sort((a, b) => a.row - b.row);

    tables.map(tableRows=> {
        const tableCellMap = {}
        const keyCellList = []
        tableRows.map(cell=>{
            tableCellMap[`${cell['row']}-${cell['col']}`] = cell
            if (cell['col'] === keyCol) {
                keyCellList.push(cell)
            }
        })

        keyCellList.map(keyCell => {
            const rowIndex = keyCell['row']
            valueColList.map(valueColIndex=> {
                const targetValueCellKey = `${rowIndex}-${valueColIndex}`
                const targetValueCell = tableCellMap[targetValueCellKey]
                if (targetValueCell) {
                    const selfKeyword = keywordMap[keyCell['content']]
                    if (selfKeyword) {
                        res.push({
                            "keyword": keywordMap[keyCell['content']],
                            "value": targetValueCell['content']
                        })
                    } else{
                        unexpected.push({
                            "unknownKeyword": keyCell['content'],
                            "value": targetValueCell['content']
                        })
                    }
                }
            })
        })
    })
    res.push({"keyword": "unKnowKey", "list": unexpected})
    return res
}
